/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './LoaderV2.style';

/**
 * LoaderV2 component
 * Loaders overlay to identify loading
 * @class LoaderV2
 * @namespace Mspwa/Component/LoaderV2/Component/LoaderV2Component */
export class LoaderV2Component extends PureComponent {
    static propTypes = {
        isLoading: PropTypes.bool.isRequired
    };

    render() {
        const { isLoading } = this.props;

        if (!isLoading) {
            return null;
        }

        return (
            <div className="ExternalLoader">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                    // style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;"
                  width="25px"
                  height="25px"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                    <circle
                      cx="50"
                      cy="50"
                      fill="none"
                      stroke="#90cc8d"
                      strokeWidth="10"
                      r="35"
                      strokeDasharray="164.93361431346415 56.97787143782138"
                    >
                        <animateTransform
                          attributeName="transform"
                          type="rotate"
                          repeatCount="indefinite"
                          dur="1s"
                          values="0 50 50;360 50 50"
                          keyTimes="0;1"
                        />
                    </circle>
                </svg>
            </div>
        );
    }
}

export default LoaderV2Component;
